export default function documentCategories(list: string[]): string[] {
  return list
}
